// @flow

import React from "react";
import { connect } from "react-redux";

import { getRouteClientIdParam } from "@selectors";
import * as accountSelectors from "@modules/account/selectors";
import * as clientsSelectors from "@modules/context/selectors";
import type { Client } from "@modules/context/types";
import actionCreators from "@modules/context/actionCreator";

type PropsFromState = $Exact<{
  clientId: number,
  client: Client | null,
  isFirstcareUser: boolean,
  hasContextSwitch: boolean,
  hasReportingContextSwitch: boolean,
}>;

type PropsFromDispatch = $Exact<{
  clearClientContext: typeof actionCreators.clearClientContext,
  getClientContext: typeof actionCreators.getClientContext,
}>;

type OwnProps = Object;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

const withClientContext = (props?: Object) => {
  return (WrappedComponent: *) => {
    class WithClientContext extends React.Component<Props> {
      componentDidMount() {
        if (!this.props.clientId) {
          return;
        }

        if (
          this.props.isFirstcareUser &&
          (!this.props.client || this.props.client.id !== this.props.clientId)
        ) {
          this.props.getClientContext({ clientId: this.props.clientId });
        }
      }

      render() {
        return <WrappedComponent {...props} {...this.props} />;
      }
    }

    const mapStateToProps = (state, ownProps): PropsFromState => {
      const clientId = getRouteClientIdParam(ownProps);

      return {
        clientId,
        client: clientsSelectors.getClientContext(state),
        isFirstcareUser: accountSelectors.isFirstCareUser(state),
        hasContextSwitch: accountSelectors.hasClientContextSwitch(state),
        hasReportingContextSwitch: accountSelectors.hasReportingClientContextSwitch(state),
      };
    };

    const mapDispatchToProps: PropsFromDispatch = {
      clearClientContext: actionCreators.clearClientContext,
      getClientContext: actionCreators.getClientContext,
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithClientContext);
  };
};

export default withClientContext;
